// Org-level Personal Assistant enablement helpers (PA-1a).
//
// Per docs/planning/personal_assistant_mode_plan.md §3.1 — gated by
// `organizations.personal_assistant_enabled` (default false).

/** Defensive boolean coercion. Anything other than literal `true` returns false (fail closed). */
export function coercePersonalAssistantEnabled(raw: unknown): boolean {
  return raw === true;
}
